import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import './../home-style.scss'
import { FetchDashboarddataNew } from '../../../services/api'
import Prgraph from './../components/Prgraph/Prgraph'
import Yieldgraph from './../components/Yieldgraph/Yieldgraph'
import EnergyGraph from './../components/EnergyGraph/EnergyGraph'
import PotfolioRepGraph from './../components/PotfolioRepGraph/PotfolioRepGraph'
import AnimatedLoader from '../../../components/AnimatedLoader/AnimatedLoader.jsx'
import CustomAlert from '../../../components/CustomAlert/CustomAlert.jsx'
import { useLocation } from 'react-router-dom'
import usePermission from '../../../hooks/usePermission'

const HomeMobileView = () => {
    const [dashboardData, setDashboardData] = React.useState([])
    const [userData, setUserData] = React.useState({})
    const [loading, setLoading] = useState(true)
    const [loginSuccessHome, setLoginSuccesshome] = useState(false)
    const { state } = useLocation()
    const { is, user } = usePermission()

    useEffect(() => {
        setLoginSuccesshome(state?.loginSuccess)
    }, [state?.loginSuccess])

    useEffect(() => {
        HandleDashboarddata()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const token = localStorage.getItem('accessToken')

    const HandleDashboarddata = () => {
        // Legacy support or fallback to Context User
        const userRoleName = user?.role?.name || localStorage.getItem('userType') || 'User';

        setUserData({
            Usertype: user?.name || userRoleName, // Display Name
            UserID: user?.id || localStorage.getItem('userId'),
        })

        let IdUser = user?.id || localStorage.getItem('userId')

        if (is('Super Admin') || is('Admin') || user?.userType === 'internal') {
            IdUser = 'all'
        }

        FetchDashboarddataNew(IdUser, token).then((resp) => {
            if (resp?.data) {
                localStorage.setItem('Authorised', true)
                setDashboardData(resp?.data)
                setLoading(false)
            } else {
                if (resp?.response?.data?.statusCode === 401) {
                    localStorage.setItem('Authorised', false)
                }
            }
        })
    }

    const alertClose = (event, reason) => {
        if (reason === 'clickaway') {
            return
        }
        setLoginSuccesshome(false)
    }

    return (
        <React.Fragment>
            <CustomAlert
                open={loginSuccessHome}
                handleClose={alertClose}
                message="You are successfully logged in"
            />

            {loading ? (
                <AnimatedLoader style={{ height: '40px', width: '40px' }} />
            ) : (
                <Box className="mobile-home-view">
                    {/* Header Cards Stack */}
                    <Grid container spacing={2} className="mb_20">
                        <Grid item xs={12}>
                            <div className="hello_txt" style={{ fontSize: '32px' }}>Hello, {userData?.Usertype}</div>
                            <div className="welcome_txt" style={{ fontSize: '18px' }}>Welcome Back</div>
                        </Grid>

                        <Grid item xs={6}>
                            <div className="total_plants">
                                <div className="total_plants_title">Plants</div>
                                <div className="h2">{dashboardData?.count}</div>
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div className="total_size">
                                <div className="total_plants_title">Size (MW)</div>
                                <div className=" h2" style={{ textAlign: 'center', fontSize: '28px' }}>
                                    {parseFloat(dashboardData?.totalPlantSize / 1000).toFixed(4)}{' '}
                                </div>
                            </div>
                        </Grid>
                    </Grid>

                    {/* Graphs Stack */}
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Prgraph token={token} />
                        </Grid>
                        <Grid item xs={12}>
                            <Yieldgraph token={token} />
                        </Grid>
                        <Grid item xs={12}>
                            <EnergyGraph token={token} />
                        </Grid>
                        <Grid item xs={12}>
                            <div className="graph_bg">
                                <div className="h1 mb_10">Portfolio Representation</div>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <PotfolioRepGraph token={token} />
                                    </Grid>
                                </Grid>
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            )}
        </React.Fragment>
    )
}

export default HomeMobileView
